import styled from "styled-components";

export const HomeBannerContainer = styled.div`
  width: 100%;
  margin: 0 auto -50px auto;
  height: ${({ small }) => {
    if (small) return "200px;";
    else return "340px;";
  }};
  background-image: url("/assets/page-banner-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
`;

export const HomeButtonContainer = styled.div`
  width: 100%;
  text-align: left;
  margin-top: 10px;
`;
export const HomeTitleBox = styled.div`
  width: 675px;
  height: fit-content;
  margin-left: 146px;
  margin-top: 48px;
  margin-bottom: 47px;
`;

export const HomeWelcomeBox = styled.div`
  width: 525px;
  height: fit-content;
  margin-left: 146px;
  margin-top: 48px;
  margin-bottom: 47px;
`;

export const HomeDescriptionWrapper = styled.div`
  margin-top: 48px;
  margin-bottom: 31px;
`;

export const HomeBannerBackground = styled.div`
  position: absolute;
  top: 100%;
  width: 100%;
  height: 320px;
  bottom: 0;
  z-index: 1;
  background-image: url("/assets/home-banner-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
`;
